const config = {
  env: process.env.NODE_ENV,
  publicUrl: process.env.PUBLIC_URL,
  apiUrl: process.env.REACT_APP_API_URL,
  audience: process.env.REACT_APP_AUDIENCE,
  clientId: process.env.REACT_APP_WEB_CLIENT_ID,
  clientSecret: process.env.REACT_APP_WEB_CLIENT_SECRET,
};

export default config;
